export { default } from './ExchangeView';
